/**
 * Cursos de la Escuela de Caución y sus fechas de inscripción.
 * Una vez al año: actualizá las fechas acá y listo.
 *
 * Formato de fecha: 'AAAA-MM-DD' (hora de Argentina).
 * - apertura: desde ese día se puede anotar (opcional; si no está, ya está abierto)
 * - cierre:   hasta ese día inclusive (opcional; si no está, no cierra nunca)
 */
export const COURSES = [
  {
    name: 'Introducción al Seguro de Caución',
    id: 'introduccionAlSeguroDeCaucion',
    apertura: null,
    cierre: '2026-10-14', // TODO: fecha real
  },
  {
    name: 'Cobranza y Refacturación',
    id: 'cobranzaYRefacturacion',
    apertura: null,
    cierre: '2026-10-28', // TODO: fecha real
  },
  {
    name: 'Suscripción de Riesgos',
    id: 'suscripcionDeRiesgos',
    apertura: null,
    cierre: '2026-10-22', // TODO: fecha real
  },
  {
    name: 'Garantías Judiciales y Siniestros',
    id: 'garantiasJudicialesYSiniestros',
    apertura: null,
    cierre: '2026-11-04', // TODO: fecha real
  },
]

export const EXTRAS = [
  {
    name: 'Masterclass',
    id: 'masterClass',
    apertura: null,
    cierre: '2026-10-01', // TODO: fecha real
  },
]

/**
 * Devuelve el estado de un curso según la fecha de hoy:
 * ''              → inscripción abierta
 * 'Próximamente'  → todavía no abrió
 * 'Finalizado'    → ya cerró
 */
export function estadoCurso(curso, ahora = new Date()) {
  if (curso.apertura && ahora < new Date(`${curso.apertura}T00:00:00-03:00`)) return 'Próximamente'
  if (curso.cierre && ahora > new Date(`${curso.cierre}T23:59:59-03:00`)) return 'Finalizado'
  return ''
}
